import React from "react";
import './layout_detail.css'

export default function LayoutDetail() {
    return (
        <div>Layout Detail</div>
    )
}